import { type ApiResponse, ApiService } from "../../../server/api/client";
import type { UUID } from "../../../utils/uuid";

export class SlackChannelService extends ApiService {
  module = "segments";

  async checkSlackChannels(value: UUID[]): Promise<ApiResponse<{ [key: string]: boolean }>> {
    return await this.post("checkSlackChannels", { channels: value });
  }
}
